module.exports = __webpack_public_path__ + "img/illust_02_focus2.83b7800e.svg";